'use client'

import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { SiteSection } from '@/components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

const EXITS = [
  { key: 'dictation', href: '/dictation' },
  { key: 'transcription', href: '/transcription' },
  { key: 'meetingNotes', href: '/meeting-notes' },
] as const

export function HomeEndCta() {
  const { t } = useTranslation(['web'])
  return (
    <SiteSection tone="ink" trackingKey="end_cta">
      <h2
        data-display-font=""
        className="font-display text-(length:--fs-marketing-h2) leading-[1.22] font-semibold tracking-[0.005em]"
      >
        {t('web:homePage.endCta.title')}
      </h2>
      <div className="mt-(--gap-xl) grid grid-cols-3 gap-x-(--gap-lg) [@media(max-width:860px)]:grid-cols-1">
        {EXITS.map(({ key, href }) => (
          <Link
            key={key}
            href={href}
            onClick={() => trackSiteLinkClicked('end_cta', href)}
            className="group flex flex-col gap-2.5 border-t border-inv-line pt-5 text-background focus-visible:rounded-[2px] focus-visible:outline-2 focus-visible:outline-offset-8 focus-visible:outline-background [@media(max-width:860px)]:pb-5"
          >
            <span
              data-display-font=""
              className="font-display text-[length:clamp(21px,2.1vw,26px)] font-semibold"
            >
              {t(`web:homePage.services.${key}.name`)}
              <span
                aria-hidden="true"
                className="ml-2.5 inline-block transition-transform duration-180 group-hover:translate-x-1 group-focus-visible:translate-x-1"
              >
                →
              </span>
            </span>
            <span className="text-md leading-[1.7] text-background/70">
              {t(`web:homePage.endCta.${key}Note`)}
            </span>
          </Link>
        ))}
      </div>
      <p className="mt-(--gap-xl) font-mono text-(length:--fs-meta)">
        <Link
          href="/pricing"
          onClick={() => trackSiteLinkClicked('end_cta', '/pricing')}
          className="border-b border-background/45 text-background transition-colors hover:border-background focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-background"
        >
          {t('web:homePage.endCta.pricing')}
        </Link>
      </p>
    </SiteSection>
  )
}
